var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('popup-content',[_c('text-content',{staticClass:"pc-popup-swap-injuries-request-success-text text-center",attrs:{"size":'sm2',"weight":'medium',"line-height":'multi'}},[_vm._v(_vm._s(_vm.description))])],1),_c('popup-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }